var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 47,
    viewBox: "0 0 573 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V7.65242H10.439L0 20.4932V27.7687L13.39 11.2707L23.062 23.1399H26H28.9423L38.6143 11.2707L52.0043 27.7687V20.4932L41.5653 7.65242H52.039V0H0ZM26 19.5294L16.3237 7.65242H35.6807L26 19.5294Z",
    fill: "#28141C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0043 36.3383L41.5653 23.4975H38.6273H35.6807L26 35.3745L16.3237 23.4975H13.377H10.439L0 36.3383V38.985V43.6137V46.6374H52.039V38.985H52.0043V36.3383ZM3.757 38.985L13.39 27.1158L23.062 38.985H3.757ZM38.6143 27.1158L48.2473 38.985H28.9467L38.6143 27.1158Z",
    fill: "#28141C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6118 31.5146L35.5477 34.2627L38.6118 37.0108L41.6759 34.2627L38.6118 31.5146Z",
    fill: "#E02229"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3868 31.5126L10.3227 34.2607L13.3868 37.0088L16.4509 34.2607L13.3868 31.5126Z",
    fill: "#E02229"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9977 9.62671L22.9336 12.3748L25.9977 15.1229L29.0618 12.3748L25.9977 9.62671Z",
    fill: "#E02229"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15.1222L48.9364 12.3745L52 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1222V12.3745V9.62674L3.06367 12.3745L0 15.1222Z",
    fill: "#E02229"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.039 0V7.65242H62.478L52.039 20.4932V27.7687L65.429 11.2707L75.101 23.1399H78.039H80.9813L90.6533 11.2707L104.043 27.7687V20.4932L93.6043 7.65242H104.078V0H52.039ZM78.039 19.5294L68.3627 7.65242H87.7197L78.039 19.5294Z",
    fill: "#28141C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.043 36.3383L93.6043 23.4975H90.6663H87.7197L78.039 35.3745L68.3627 23.4975H65.416H62.478L52.039 36.3383V38.985V43.6137V46.6374H104.078V38.985H104.043V36.3383ZM55.796 38.985L65.429 27.1158L75.101 38.985H55.796ZM90.6533 27.1158L100.286 38.985H80.9857L90.6533 27.1158Z",
    fill: "#28141C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6508 31.5146L87.5867 34.2627L90.6508 37.0108L93.7149 34.2627L90.6508 31.5146Z",
    fill: "#E02229"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4258 31.5126L62.3617 34.2607L65.4258 37.0088L68.4899 34.2607L65.4258 31.5126Z",
    fill: "#E02229"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0367 9.62671L74.9726 12.3748L78.0367 15.1229L81.1008 12.3748L78.0367 9.62671Z",
    fill: "#E02229"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.039 15.1222L100.975 12.3745L104.039 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.039 15.1222V12.3745V9.62674L55.1027 12.3745L52.039 15.1222Z",
    fill: "#E02229"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.078 0V7.65242H114.517L104.078 20.4932V27.7687L117.468 11.2707L127.14 23.1399H130.078H133.02L142.692 11.2707L156.082 27.7687V20.4932L145.643 7.65242H156.117V0H104.078ZM130.078 19.5294L120.402 7.65242H139.759L130.078 19.5294Z",
    fill: "#28141C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 36.3383L145.643 23.4975H142.705H139.759L130.078 35.3745L120.402 23.4975H117.455H114.517L104.078 36.3383V38.985V43.6137V46.6374H156.117V38.985H156.082V36.3383ZM107.835 38.985L117.468 27.1158L127.14 38.985H107.835ZM142.692 27.1158L152.325 38.985H133.025L142.692 27.1158Z",
    fill: "#28141C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.69 31.5146L139.626 34.2627L142.69 37.0108L145.754 34.2627L142.69 31.5146Z",
    fill: "#E02229"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.465 31.5126L114.401 34.2607L117.465 37.0088L120.529 34.2607L117.465 31.5126Z",
    fill: "#E02229"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.076 9.62671L127.012 12.3748L130.076 15.1229L133.14 12.3748L130.076 9.62671Z",
    fill: "#E02229"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.078 15.1222L153.014 12.3745L156.078 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.078 15.1222V12.3745V9.62674L107.142 12.3745L104.078 15.1222Z",
    fill: "#E02229"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M156.117 0V7.65242H166.556L156.117 20.4932V27.7687L169.507 11.2707L179.179 23.1399H182.117H185.059L194.731 11.2707L208.121 27.7687V20.4932L197.682 7.65242H208.156V0H156.117ZM182.117 19.5294L172.441 7.65242H191.798L182.117 19.5294Z",
    fill: "#28141C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M208.121 36.3383L197.682 23.4975H194.744H191.798L182.117 35.3745L172.441 23.4975H169.494H166.556L156.117 36.3383V38.985V43.6137V46.6374H208.156V38.985H208.121V36.3383ZM159.874 38.985L169.507 27.1158L179.179 38.985H159.874ZM194.731 27.1158L204.364 38.985H185.064L194.731 27.1158Z",
    fill: "#28141C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M194.729 31.5146L191.665 34.2627L194.729 37.0108L197.793 34.2627L194.729 31.5146Z",
    fill: "#E02229"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.504 31.5126L166.44 34.2607L169.504 37.0088L172.568 34.2607L169.504 31.5126Z",
    fill: "#E02229"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M182.115 9.62671L179.051 12.3748L182.115 15.1229L185.179 12.3748L182.115 9.62671Z",
    fill: "#E02229"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M208.117 15.1222L205.053 12.3745L208.117 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.117 15.1222V12.3745V9.62674L159.181 12.3745L156.117 15.1222Z",
    fill: "#E02229"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M208.156 0V7.65242H218.595L208.156 20.4932V27.7687L221.546 11.2707L231.218 23.1399H234.156H237.098L246.77 11.2707L260.16 27.7687V20.4932L249.721 7.65242H260.195V0H208.156ZM234.156 19.5294L224.48 7.65242H243.837L234.156 19.5294Z",
    fill: "#28141C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M260.16 36.3383L249.721 23.4975H246.783H243.837L234.156 35.3745L224.48 23.4975H221.533H218.595L208.156 36.3383V38.985V43.6137V46.6374H260.195V38.985H260.16V36.3383ZM211.913 38.985L221.546 27.1158L231.218 38.985H211.913ZM246.77 27.1158L256.403 38.985H237.103L246.77 27.1158Z",
    fill: "#28141C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M246.768 31.5146L243.704 34.2627L246.768 37.0108L249.832 34.2627L246.768 31.5146Z",
    fill: "#E02229"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M221.543 31.5126L218.479 34.2607L221.543 37.0088L224.607 34.2607L221.543 31.5126Z",
    fill: "#E02229"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M234.154 9.62671L231.09 12.3748L234.154 15.1229L237.218 12.3748L234.154 9.62671Z",
    fill: "#E02229"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M260.156 15.1222L257.092 12.3745L260.156 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M208.156 15.1222V12.3745V9.62674L211.22 12.3745L208.156 15.1222Z",
    fill: "#E02229"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M260.195 0V7.65242H270.634L260.195 20.4932V27.7687L273.585 11.2707L283.257 23.1399H286.195H289.137L298.809 11.2707L312.199 27.7687V20.4932L301.76 7.65242H312.234V0H260.195ZM286.195 19.5294L276.519 7.65242H295.876L286.195 19.5294Z",
    fill: "#28141C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M312.199 36.3383L301.76 23.4975H298.822H295.876L286.195 35.3745L276.519 23.4975H273.572H270.634L260.195 36.3383V38.985V43.6137V46.6374H312.234V38.985H312.199V36.3383ZM263.952 38.985L273.585 27.1158L283.257 38.985H263.952ZM298.809 27.1158L308.442 38.985H289.142L298.809 27.1158Z",
    fill: "#28141C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M298.807 31.5146L295.743 34.2627L298.807 37.0108L301.871 34.2627L298.807 31.5146Z",
    fill: "#E02229"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M273.582 31.5126L270.518 34.2607L273.582 37.0088L276.646 34.2607L273.582 31.5126Z",
    fill: "#E02229"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M286.193 9.62671L283.129 12.3748L286.193 15.1229L289.257 12.3748L286.193 9.62671Z",
    fill: "#E02229"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M312.195 15.1222L309.131 12.3745L312.195 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M260.195 15.1222V12.3745V9.62674L263.259 12.3745L260.195 15.1222Z",
    fill: "#E02229"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M312.234 0V7.65242H322.673L312.234 20.4932V27.7687L325.624 11.2707L335.296 23.1399H338.234H341.176L350.848 11.2707L364.238 27.7687V20.4932L353.799 7.65242H364.273V0H312.234ZM338.234 19.5294L328.558 7.65242H347.915L338.234 19.5294Z",
    fill: "#28141C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M364.238 36.3383L353.799 23.4975H350.861H347.915L338.234 35.3745L328.558 23.4975H325.611H322.673L312.234 36.3383V38.985V43.6137V46.6374H364.273V38.985H364.238V36.3383ZM315.991 38.985L325.624 27.1158L335.296 38.985H315.991ZM350.848 27.1158L360.481 38.985H341.181L350.848 27.1158Z",
    fill: "#28141C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M350.846 31.5146L347.782 34.2627L350.846 37.0108L353.91 34.2627L350.846 31.5146Z",
    fill: "#E02229"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M325.621 31.5126L322.557 34.2607L325.621 37.0088L328.685 34.2607L325.621 31.5126Z",
    fill: "#E02229"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M338.232 9.62671L335.168 12.3748L338.232 15.1229L341.296 12.3748L338.232 9.62671Z",
    fill: "#E02229"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M364.234 15.1222L361.17 12.3745L364.234 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M312.234 15.1222V12.3745V9.62674L315.298 12.3745L312.234 15.1222Z",
    fill: "#E02229"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M364.273 0V7.65242H374.712L364.273 20.4932V27.7687L377.663 11.2707L387.335 23.1399H390.277H393.22L402.887 11.2707L416.277 27.7687V20.4932L405.838 7.65242H416.312V0H364.273ZM390.273 19.5294L380.597 7.65242H399.954L390.273 19.5294Z",
    fill: "#28141C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M416.273 36.3383L405.834 23.4975H402.896H399.949L390.273 35.3745L380.597 23.4975H377.65H374.712L364.273 36.3383V38.985V43.6137V46.6374H416.312V38.985H416.277V36.3383H416.273ZM368.03 38.985L377.663 27.1158L387.335 38.985H368.03ZM402.887 27.1158L412.52 38.985H393.22L402.887 27.1158Z",
    fill: "#28141C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M402.884 31.514L399.82 34.2621L402.884 37.0102L405.948 34.2621L402.884 31.514Z",
    fill: "#E02229"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M377.656 31.5148L374.592 34.2629L377.656 37.011L380.72 34.2629L377.656 31.5148Z",
    fill: "#E02229"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M390.27 9.62607L387.206 12.3742L390.27 15.1223L393.334 12.3742L390.27 9.62607Z",
    fill: "#E02229"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M416.273 15.1222L413.209 12.3745L416.273 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M364.273 15.1222V12.3745V9.62674L367.337 12.3745L364.273 15.1222Z",
    fill: "#E02229"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M416.312 0V7.65242H426.751L416.312 20.4932V27.7687L429.702 11.2707L439.374 23.1399H442.316H445.259L454.926 11.2707L468.316 27.7687V20.4932L457.877 7.65242H468.351V0H416.312ZM442.312 19.5294L432.636 7.65242H451.993L442.312 19.5294Z",
    fill: "#28141C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M468.312 36.3383L457.873 23.4975H454.935H451.988L442.312 35.3745L432.636 23.4975H429.689H426.751L416.312 36.3383V38.985V43.6137V46.6374H468.351V38.985H468.316V36.3383H468.312ZM420.069 38.985L429.702 27.1158L439.374 38.985H420.069ZM454.926 27.1158L464.559 38.985H445.259L454.926 27.1158Z",
    fill: "#28141C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M454.923 31.514L451.859 34.2621L454.923 37.0102L457.987 34.2621L454.923 31.514Z",
    fill: "#E02229"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M429.695 31.5148L426.631 34.2629L429.695 37.011L432.759 34.2629L429.695 31.5148Z",
    fill: "#E02229"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M442.309 9.62607L439.245 12.3742L442.309 15.1223L445.373 12.3742L442.309 9.62607Z",
    fill: "#E02229"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M468.312 15.1222L465.248 12.3745L468.312 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M416.312 15.1222V12.3745V9.62674L419.376 12.3745L416.312 15.1222Z",
    fill: "#E02229"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M468.351 0V7.65242H478.79L468.351 20.4932V27.7687L481.741 11.2707L491.413 23.1399H494.355H497.298L506.965 11.2707L520.355 27.7687V20.4932L509.916 7.65242H520.39V0H468.351ZM494.351 19.5294L484.675 7.65242H504.032L494.351 19.5294Z",
    fill: "#28141C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M520.351 36.3383L509.912 23.4975H506.974H504.027L494.351 35.3745L484.675 23.4975H481.728H478.79L468.351 36.3383V38.985V43.6137V46.6374H520.39V38.985H520.355V36.3383H520.351ZM472.108 38.985L481.741 27.1158L491.413 38.985H472.108ZM506.965 27.1158L516.598 38.985H497.298L506.965 27.1158Z",
    fill: "#28141C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M506.962 31.514L503.898 34.2621L506.962 37.0102L510.026 34.2621L506.962 31.514Z",
    fill: "#E02229"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M481.734 31.5148L478.67 34.2629L481.734 37.011L484.798 34.2629L481.734 31.5148Z",
    fill: "#E02229"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M494.348 9.62607L491.284 12.3742L494.348 15.1223L497.412 12.3742L494.348 9.62607Z",
    fill: "#E02229"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M520.351 15.1222L517.287 12.3745L520.351 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M468.351 15.1222V12.3745V9.62674L471.415 12.3745L468.351 15.1222Z",
    fill: "#E02229"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M520.39 0V7.65242H530.829L520.39 20.4932V27.7687L533.78 11.2707L543.452 23.1399H546.394H549.337L559.009 11.2707L572.399 27.7687V20.4932L561.96 7.65242H572.429V0H520.39ZM546.394 19.5294L536.718 7.65242H556.075L546.394 19.5294Z",
    fill: "#28141C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M572.394 36.3383L561.955 23.4975H559.017H556.071L546.394 35.3745L536.718 23.4975H533.771H530.829L520.39 36.3383V38.985V43.6137V46.6374H572.429V38.985H572.394V36.3383ZM524.147 38.985L533.78 27.1158L543.452 38.985H524.147ZM559.009 27.1158L568.642 38.985H549.341L559.009 27.1158Z",
    fill: "#28141C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M559.005 31.5134L555.941 34.2615L559.005 37.0096L562.069 34.2615L559.005 31.5134Z",
    fill: "#E02229"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M533.777 31.5142L530.712 34.2623L533.777 37.0104L536.841 34.2623L533.777 31.5142Z",
    fill: "#E02229"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M546.39 9.62552L543.326 12.3736L546.39 15.1217L549.455 12.3736L546.39 9.62552Z",
    fill: "#E02229"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M572.394 15.1222L569.331 12.3745L572.394 9.62674V12.3745V15.1222Z",
    fill: "#E02229"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M520.39 15.1222V12.3745V9.62674L523.454 12.3745L520.39 15.1222Z",
    fill: "#E02229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderImg);
export default __webpack_public_path__ + "static/media/underImg.2c27be10e3dd77e829a2caa6d1c85c1d.svg";
export { ForwardRef as ReactComponent };